(() => {
  const playVideo = (card) => {
    const video = card.querySelector(".simple-media-card__video video");
    if (video) {
      const button = card.querySelector(".js-play-video");

      if (video.parentElement.classList.contains("autoplay")) {
        video.autoplay = true;
        if (button) {
          button.classList.add("active");
        }
      }

      if (video.autoplay && video.paused) {
        video.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      }

      if (!video.autoplay && button) {
        button.classList.remove("active");
      }

      if (video.parentElement.dataset.videoLoop === "false") {
        video.addEventListener("ended", () => {
          button.classList.remove("active");
        });
      }
    }

    const videoUrl = card.querySelector(".simple-media-card__video iframe");
    if (videoUrl) {
      const button = card.querySelector(".js-play-video");
      if (videoUrl.parentElement.classList.contains("autoplay")) {
        if (videoUrl.classList.contains("js-youtube")) {
          videoUrl.contentWindow.postMessage(
            '{"event":"command","func":"' + "playVideo" + '","args":""}',
            "*"
          );
          if (videoUrl.classList.contains("video-muted")) {
            videoUrl.contentWindow.postMessage(
              '{"event":"command","func":"' + "mute" + '","args":""}',
              "*"
            );
          } else {
            videoUrl.contentWindow.postMessage(
              '{"event":"command","func":"' + "unMute" + '","args":""}',
              "*"
            );
          }
          videoUrl.classList.add("video-play");
          videoUrl.classList.remove("video-pause");
        } else if (videoUrl.classList.contains("js-vimeo")) {
          videoUrl.contentWindow.postMessage('{"method":"play"}', "*");
          if (videoUrl.classList.contains("video-muted")) {
            videoUrl.contentWindow.postMessage(
              '{"method":"setVolume", "value":0}',
              "*"
            );
          } else {
            videoUrl.contentWindow.postMessage(
              '{"method":"setVolume", "value":1}',
              "*"
            );
          }
          videoUrl.classList.add("video-play");
          videoUrl.classList.remove("video-pause");
        }
        if (button) {
          button.classList.add("active");
        }
      }

      if (
        videoUrl.parentElement.classList.contains("autoplay") &&
        videoUrl.classList.contains("video-pause")
      ) {
        if (videoUrl.classList.contains("js-youtube")) {
          videoUrl.contentWindow.postMessage(
            '{"event":"command","func":"' + "playVideo" + '","args":""}',
            "*"
          );
          if (videoUrl.classList.contains("video-muted")) {
            videoUrl.contentWindow.postMessage(
              '{"event":"command","func":"' + "mute" + '","args":""}',
              "*"
            );
          } else {
            videoUrl.contentWindow.postMessage(
              '{"event":"command","func":"' + "unMute" + '","args":""}',
              "*"
            );
          }
          videoUrl.classList.add("video-play");
          videoUrl.classList.remove("video-pause");
        } else if (videoUrl.classList.contains("js-vimeo")) {
          videoUrl.contentWindow.postMessage('{"method":"play"}', "*");
          if (videoUrl.classList.contains("video-muted")) {
            videoUrl.contentWindow.postMessage(
              '{"method":"setVolume", "value":0}',
              "*"
            );
          } else {
            videoUrl.contentWindow.postMessage(
              '{"method":"setVolume", "value":1}',
              "*"
            );
          }
          videoUrl.classList.add("video-play");
          videoUrl.classList.remove("video-pause");
        }
      }

      if (!videoUrl.parentElement.classList.contains("autoplay") && button) {
        button.classList.remove("active");
      }
    }
  };

  const stopVideo = (card) => {
    const videoActive = card.querySelector(".simple-media-card__video video");
    if (videoActive) {
      videoActive.pause();
    }

    const videoUrlActive = card.querySelector(
      ".simple-media-card__video iframe"
    );
    if (videoUrlActive) {
      if (videoUrlActive.classList.contains("js-youtube")) {
        videoUrlActive.contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*"
        );
        videoUrlActive.classList.add("video-pause");
        videoUrlActive.classList.remove("video-play");
      } else if (videoUrlActive.classList.contains("js-vimeo")) {
        videoUrlActive.contentWindow.postMessage('{"method":"pause"}', "*");
        videoUrlActive.classList.add("video-pause");
        videoUrlActive.classList.remove("video-play");
      }
    }
  };

  const controlsVideo = (section) => {
    const buttonsPlay = section.querySelectorAll(".js-play-video");
    const buttonsSound = section.querySelectorAll(".js-sound-video");

    buttonsPlay.forEach((button) => {
      button.addEventListener("click", (event) => onClickPlayPause(event));
      function onClickPlayPause(event) {
        const buttonPlay = event.currentTarget;
        const parentElement = event.currentTarget.parentNode;
        if (
          buttonPlay.classList.contains("js-play-video") &&
          parentElement.previousElementSibling.classList.contains(
            "simple-media-card__video"
          )
        ) {
          const video =
            parentElement.previousElementSibling.querySelector("video");
          if (video) {
            if (video.paused) {
              video.play().catch((error) => {
                console.error("Error playing video:", error);
              });
            } else {
              video.pause();
            }
            buttonPlay.classList.toggle("active");
          }

          const videoUrl =
            parentElement.previousElementSibling.querySelector("iframe");
          if (videoUrl) {
            if (videoUrl.classList.contains("video-pause")) {
              if (videoUrl.classList.contains("js-youtube")) {
                videoUrl.contentWindow.postMessage(
                  '{"event":"command","func":"' + "playVideo" + '","args":""}',
                  "*"
                );
                if (videoUrl.classList.contains("video-muted")) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "mute" + '","args":""}',
                    "*"
                  );
                } else {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "unMute" + '","args":""}',
                    "*"
                  );
                }
                videoUrl.classList.add("video-play");
                videoUrl.classList.remove("video-pause");
              } else if (videoUrl.classList.contains("js-vimeo")) {
                videoUrl.contentWindow.postMessage('{"method":"play"}', "*");
                if (videoUrl.classList.contains("video-muted")) {
                  videoUrl.contentWindow.postMessage(
                    '{"method":"setVolume", "value":0}',
                    "*"
                  );
                } else {
                  videoUrl.contentWindow.postMessage(
                    '{"method":"setVolume", "value":1}',
                    "*"
                  );
                }
                videoUrl.classList.add("video-play");
                videoUrl.classList.remove("video-pause");
              }
            } else {
              if (videoUrl.classList.contains("js-youtube")) {
                videoUrl.contentWindow.postMessage(
                  '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
                  "*"
                );
                videoUrl.classList.add("video-pause");
                videoUrl.classList.remove("video-play");
              } else if (videoUrl.classList.contains("js-vimeo")) {
                videoUrl.contentWindow.postMessage('{"method":"pause"}', "*");
                videoUrl.classList.add("video-pause");
                videoUrl.classList.remove("video-play");
              }
            }
            buttonPlay.classList.toggle("active");
          }
        }
      }
    });

    buttonsSound.forEach((button) => {
      button.addEventListener("click", (event) => onClickSound(event));
      function onClickSound(event) {
        const buttonSound = event.currentTarget;
        const parentElement = event.currentTarget.parentNode;
        if (
          buttonSound.classList.contains("js-sound-video") &&
          parentElement.previousElementSibling.classList.contains(
            "simple-media-card__video"
          )
        ) {
          const video =
            parentElement.previousElementSibling.querySelector("video");
          if (video) {
            if (video.muted) {
              setTimeout(() => {
                video.muted = false;
              }, 10);
            } else {
              setTimeout(() => {
                video.muted = true;
              }, 10);
            }
            buttonSound.classList.toggle("active");
          }

          const videoUrl =
            parentElement.previousElementSibling.querySelector("iframe");
          if (videoUrl) {
            if (videoUrl.classList.contains("video-muted")) {
              if (videoUrl.classList.contains("js-youtube")) {
                videoUrl.contentWindow.postMessage(
                  '{"event":"command","func":"' + "unMute" + '","args":""}',
                  "*"
                );
                videoUrl.classList.remove("video-muted");
              } else if (videoUrl.classList.contains("js-vimeo")) {
                videoUrl.contentWindow.postMessage(
                  '{"method":"setVolume", "value":1}',
                  "*"
                );
                videoUrl.classList.remove("video-muted");
              }
            } else {
              if (videoUrl.classList.contains("js-youtube")) {
                videoUrl.contentWindow.postMessage(
                  '{"event":"command","func":"' + "mute" + '","args":""}',
                  "*"
                );
                videoUrl.classList.add("video-muted");
              } else if (videoUrl.classList.contains("js-vimeo")) {
                videoUrl.contentWindow.postMessage(
                  '{"method":"setVolume", "value":0}',
                  "*"
                );
                videoUrl.classList.add("video-muted");
              }
            }
            buttonSound.classList.toggle("active");
          }
        }
      }
    });
  };

  const sliderSettings = {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
    allowTouchMove: true,
    mousewheel: {
      forceToAxis: true,
    },
  };

  const initSlider = (section) => {
    const slider = section.querySelector(".swiper--media");

    if (!slider || slider.swiper) return;

    const slidesWrapper = slider.querySelector(".simple-media-list__wrapper");
    const slides = slider.querySelectorAll(".simple-media-card--wrapper");
    const nextBtn = section.querySelector(".simple-media-button--next");
    const prevBtn = section.querySelector(".simple-media-button--prev");

    if (!slidesWrapper || !slides || slides.length === 0) {
      console.warn("[v0] Missing slider elements");
      return;
    }

    slider.classList.add("swiper");
    slidesWrapper.classList.add("swiper-wrapper");
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    const paginationEl = section.querySelector(
      ".simple-media-swiper__pagination"
    );

    if (slider.swiper) return;

    new Swiper(slider, {
      ...sliderSettings,
      loop: false,
      watchSlidesProgress: true,
      pagination: {
        el: paginationEl,
        type: "bullets",
        clickable: true,
      },
    });
  };

  const destroySlider = (section) => {
    const slider = section.querySelector(".swiper--media");
    const slidesWrapper = slider?.querySelector(".simple-media-list__wrapper");
    const slides = section.querySelectorAll(".simple-media-card--wrapper");

    if (slider?.swiper) {
      slider.swiper.destroy(true, true);
    }

    if (slider) slider.classList.remove("swiper");
    if (slidesWrapper) slidesWrapper.classList.remove("swiper-wrapper");
    slides.forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("swiper-slide");
    });
  };

  const initMediaSection = (section) => {
    if (!section || !section?.classList.contains("media-section")) return;

    const box = section.querySelector(".simple-media");

    if (!box) return;

    const hasMobileSlider =
      box.getAttribute("data-enable-mobile-slider") === "true";

    if (hasMobileSlider && window.innerWidth < 576) {
      setTimeout(() => initSlider(section), 100);
    }

    controlsVideo(section);

    const mediaCards = section.querySelectorAll(".simple-media-card");
    mediaCards.forEach((card) => {
      playVideo(card);
    });

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const mediaCards = entry.target.querySelectorAll(".simple-media-card");

        if (entry.isIntersecting) {
          mediaCards.forEach((card) => playVideo(card));
        } else {
          mediaCards.forEach((card) => stopVideo(card));
        }
      });
    });

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 576 && hasMobileSlider) {
          initSlider(section);
        } else {
          destroySlider(section);
        }
      });
    });

    sectionResizeObserver.observe(section);
    sectionObserver.observe(section);
  };

  initMediaSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initMediaSection(event.target);
  });
})();
